import React from 'react';
import styles from './UserDisplay.module.css';

export interface UserInfoProps {
  name: string;
  email?: string | null;
  className?: string;
}

const UserInfo: React.FC<UserInfoProps> = ({ 
  name, 
  email,
  className = '' 
}) => {
  return (
    <div className={`${styles.userInfo} ${className}`}>
      <h3 className={styles.userName}>{name || 'User'}</h3>
      {email && (
        <p className={styles.userEmail}>{email}</p>
      )}
    </div>
  );
};

export default UserInfo;

